import { type RootState } from "../../redux/store";
import { useSelector } from "react-redux";

const selectUnitMode = (state: RootState) => state.userPreferences.unitMode;

export const useUnitMode = () => useSelector(selectUnitMode);
